import { render, staticRenderFns } from "./CkEditorReduced.vue?vue&type=template&id=0b286b25"
import script from "./CkEditorReduced.vue?vue&type=script&lang=js"
export * from "./CkEditorReduced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports